import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Rule } from '../../../models/rule.model';

@Component({
  selector: 'app-asset-group',
  templateUrl: './asset-group.component.html',
  styleUrl: './asset-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AssetGroupComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {}
  ngOnInit(): void {}
  @Input({ required: true }) Rules: Rule[] = [];
  @Input() columns: number = 10;
}
